
<template>
    <div class= "col-md-12 ml-sm-0 col-lg-12 pt-0 px-0 pl-0">
        <div class="row mx-0">
            <div class="col-md-5 ml-sm-0 col-lg-5 pt-1 px-1 pl-5">
            </div>
            <!-- CONFIG SELECTIONNEE -->
            <select v-model="selectedValue">
                <option disabled value="">Please select one</option>
                <option v-for="item in ConfigList" :value="item">{{item}}</option>
            </select>

            <div class="col-md-2 ml-sm-0 col-lg-2 pt-1 px-1 pl-5">
                <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click='save()' :title="trans.get('common.save')">
                    <span class="glyphicon glyphicon-floppy-save" aria-hidden="true"></span>
                </button>
            </div>
        </div>
        <div class="row mx-0">
            <div class ="col-md-12 ml-sm-0 col-lg-12 pt-1 px-1 pl-5">
                <table class="table" >
                <!-- HEADER TABLEAU -->
                    <thead>
                        <th>Nom</th>
                        <th>Couleur de fond de base</th>
                        <th>Couleur du titre</th>
                        <th>Couleur de fond de tableau</th>
                        <th>Couleur du texte d'entête</th>
                        <th>Couleur du contenu de tableau</th>
                        <th>Couleur du contour de tableau</th>
                        <th>Couleur de l'adresse</th>
                        <th>Couleur de base du texte</th>
                        <th>Note de bas de page</th>
                        <th>Image de bas de page</th>
                    </thead>
                <!-- CONTENU TABLEAU -->
                    <tbody>
                        <tr  v-for="Config in Configs">
                            <td>{{Config[1]}}</td>
                            <td><squareColor :color="Config[2]" size="10" :row="Config[0]" :col="2"></squareColor>{{Config[2]}}</td>
                            <td><squareColor :color="Config[3]" size="10" :row="Config[0]" :col="3"></squareColor>{{Config[3]}}</td>
                            <td><squareColor :color="Config[4]" size="10" :row="Config[0]" :col="4"></squareColor>{{Config[4]}}</td>
                            <td><squareColor :color="Config[5]" size="10" :row="Config[0]" :col="5"></squareColor>{{Config[5]}}</td>
                            <td><squareColor :color="Config[6]" size="10" :row="Config[0]" :col="6"></squareColor>{{Config[6]}}</td>
                            <td><squareColor :color="Config[7]" size="10" :row="Config[0]" :col="7"></squareColor>{{Config[7]}}</td>
                            <td><squareColor :color="Config[8]" size="10" :row="Config[0]" :col="8"></squareColor>{{Config[8]}}</td>
                            <td><squareColor :color="Config[9]" size="10" :row="Config[0]" :col="9"></squareColor>{{Config[9]}}</td>
                            <td>{{Config[10]}}</td>
                            <td>{{Config[11]}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <input id="conf" type = "hidden" name="conf" :value='selectedValue'/>
    </div>
</template>

<script >
    import squareColor from './squareColor.vue';

    export default {
        props : ['exportconf', 'selectconf'],     
        
        data : function(){
            return {
                Configs :[],
                ConfigList:[],
                selectedValue:'',
            };
        },
        mounted: function(){
            let ConfigListTmp=[];
            let ConfigsTmp=[];
            this.exportconf.forEach(function(item) {
                ConfigListTmp.push(item[1]);
            });
            this.ConfigList = ConfigListTmp;
            this.Configs = this.exportconf;
            this.selectedValue = this.selectconf;
        },
        methods :{
            save(){                
                document.getElementById('conf').value = this.selectedValue;
                document.getElementById("formPost").submit();
            },
        }

    }

</script>